// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Block from "components/layout/Block";

// ** Styles
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledModalAuthMainSection = styled(Block)`
	position: relative;
	z-index: 1;
	background-color: transparent;
	flex-grow: 1;
	color: ${({ theme: { colors } }) => colors.whiteTrue};
	width: 100%;
	height: 100%;
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.card};
	display: flex;
	align-items: center;
	justify-content: center;

	@media (min-width: ${breakpoints.tablet - 1}px) {
		width: 550px;
	}

	@media (min-width: ${breakpoints.desktop - 1}px) {
		width: 600px;
	}
`;

// #####################################################
